/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    // calendarAuth: currentUser && currentUser.access === 'admin',

    normalRouteFilter: (route:any) => {
      // 根据路由配置中的 authCode 判断是否有权限
      const {auth = []} = currentUser || {}
      console.log('route-------------->', route);
      const {authCode} = route || {}
      if (Array.isArray(authCode)) {
        return authCode.some(item => {
          return auth.includes(item)
        })
      } else {
        return auth.includes(authCode)
      }
    },
  };
}
